import Axios from '@/utils/axios';
import { getBackendErrorMessage } from '@/utils/errorHandler';

export interface ReasonOption {
  id: string | number;
  internalReason: string;
  code: string;
}

/** Keyed by category label → array of reason options */
export type CategorizedReasons = Record<string, ReasonOption[]>;

export interface GetReasonsParams {
  state?: string;
  type?: string;
  language?: string;
  status?: string;
  excludeActors?: string;
}

export const reasonsAPI = {
  /**
   * GET /mgmt/v1/reasons/categorized-internal
   *
   * Returns reasons grouped by category. Used for cancel, failed, and
   * driver-assignment modals.
   */
  getCategorized: async (
    params: GetReasonsParams
  ): Promise<CategorizedReasons> => {
    try {
      const response = await Axios.get(
        '/mgmt/v1/reasons/categorized-internal',
        { params }
      );
      const body = response.data;
      // Unwrap if envelope
      return (body?.data ?? body) as CategorizedReasons;
    } catch (error) {
      throw new Error(getBackendErrorMessage(error));
    }
  },
};
